import React from 'react'

const Title = () => {
    return (
        <h2 style={{ fontWeight: '700' }}>T O D O</h2>
    )
}

export default Title